import { inject } from '@angular/core';
import { RedirectCommand, Router } from '@angular/router';
import {
  MainPageNavigation,
  showAssistant
} from '@ui/tenant-pool/shared/config/util';
import { UserStore } from '@ui/tenant-pool/shared/user/data-access';
import type { CanActivateFn } from '@angular/router';

/**
 * Keeps the service centre off-limits to customers who have every card
 * disabled.
 *
 * Synchronous on purpose. This runs as `canActivate` under the shell's
 * `AuthGuard`, which already blocks until the user is loaded and verified, so
 * the user is populated by the time we read it. The previous `canLoad`
 * version had to load the user itself and handle the missing-token case — and,
 * because the router skips `canLoad` once a lazy chunk is cached, it only ran
 * once per page load instead of on every navigation.
 */
export const serviceCenterGuard: CanActivateFn = () => {
  const settings = inject(UserStore).userItpSettings();

  if (showAssistant(settings)) return true;

  return new RedirectCommand(
    inject(Router).createUrlTree([`/${MainPageNavigation.LANDLORDS}`])
  );
};
